import React from 'react';

import { OneInchNetwork } from '@api';

import { ArrowLeft } from '@uikit/icons/ArrowLeft';

import { OneInchView } from '@magic-swap/components/pages/MagicSwap/types';
import NetworkOption from '@magic-swap/components/pages/MagicSwap/ui/NetworkOption';

interface MagicSwapNetworkSelectViewProps {
  networks: OneInchNetwork[];
  setNetwork: (network: OneInchNetwork) => void;
  setView: (view: OneInchView) => void;
}

const MagicSwapNetworkSelectView = ({
  networks,
  setNetwork,
  setView,
}: MagicSwapNetworkSelectViewProps) => {
  return (
    <div className="w-full flex flex-col">
      <div className="flex gap-1 items-center justify-start mb-6">
        <button className="button button-ghost p-1" onClick={() => setView('main')}>
          <ArrowLeft className="icon-lg" />
        </button>

        <h2 className="text-[28px] font-semibold">Choose a Network</h2>
      </div>

      <div className="flex flex-col">
        {networks.map((network) => {
          return (
            <button
              key={network.attributes.name}
              onClick={() => {
                setNetwork(network);
                setView('main');
              }}
              className="w-full"
            >
              <NetworkOption network={network} />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default MagicSwapNetworkSelectView;
